import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'chacras',
    pathMatch: 'full'
  },
  {
    path: 'chacras',
    loadChildren: () => import('./chacra/chacra.module').then(m => m.ChacraModule)
  },
  {
    path: 'empresas',
    loadChildren: () => import('./empresa/empresa.module').then(m => m.EmpresaModule)
  },
  {
    path: 'mensajes',
    loadChildren: () => import('./mensajes/mensajes.module').then(m => m.MensajesModule)
  },
  {
    path: 'mapa',
    loadChildren: () => import('./map/map.module').then(m => m.MapModule)
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '**',
    redirectTo: 'chacras'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeaturesRoutingModule {}
